import { defineAction } from '~/prix'
import { featureCollection, latitude, longitude, multiPolygon, polygon } from '~/prix/types/presets/geo'
import healthProfessionalEditCoverageAreaAction from './healthProfessionalEditCoverageArea.action.json' with { type: 'json' }
import { z } from 'zod'

const polygonOrMultiPolygon = z.union([polygon(), multiPolygon()])

const healthProfessionalEditCoverageAreaDefinition = defineAction({
  ...healthProfessionalEditCoverageAreaAction,

  input: z.object({
    delimitationPolygon: polygonOrMultiPolygon,
    delimitationId: z.number(),
    delimitationType: z.enum(['municipality']),
    delimitationKey: z.string().nullish(),
    featureCollection: featureCollection(
      z.union([polygon(), multiPolygon(), z.null()]),
      z.object({
        key: z.string(),
        cns: z.string(),
        name: z.string(),
        teamIne: z.string().nullish(),
        healthUnitCnes: z.string().nullish(),
        latitude: latitude().nullish(),
        longitude: longitude().nullish(),
        kind: z
          .enum([
            'smartMapping',
            'deprecated',
            'manualDrawing',
            'authorityProvided',
            'openStreetMapSourced',
          ])
          .nullish(),
      }),
    ),
  }),
  output: z.object({
    success: z.boolean(),
  }),
})

export default healthProfessionalEditCoverageAreaDefinition
